<template lang="pug">
ValidationObserver(ref='validator')
  form(@submit.prevent='() => {}')
    v-row#name(v-if='!options.hide.name')
      v-col.py-0(cols=12)
        label.md-form-label
          | {{ $t("commonWords.name") }}
      v-col(cols=12 style='padding-top: 0')
        ValidatedInput(
          :name='$t("commonWords.name")'
          rules='required'
          v-model='requestTemplate.name',
          :disabled='options.name.disabled || readOnly'
          type='text')
    v-row#urlPreview(v-if='!options.hide.urlPreview')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.urlPreview") }}
      v-col(cols=12)
        URLPreviewer(v-bind='requestTemplate')
    v-row#requestType(v-if='!options.hide.requestType')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.requestType") }}
      v-col(cols=12)
        ValidatedField(
          :name='$t("integrations.requestType")'
          rules='required')
          md-select(
            v-model='requestTemplate.requestType',
            :disabled='readOnly')
            md-option(value='rest') REST
          md-icon.error(v-slot:error-icon) close
          md-icon.success(v-slot:success-icon) done
    v-row#requestType(v-if='!options.hide.method')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.requestMethod") }}
      v-col(cols=12)
        ValidatedField(
          :name='$t("integrations.requestMethod")'
          rules='required')
          md-select(
            v-model='requestTemplate.method',
            :disabled='options.method.disabled || readOnly')
            md-option(value='GET') GET
            md-option(value='POST') POST
            md-option(value='PUT') PUT
          md-icon.error(v-slot:error-icon) close
          md-icon.success(v-slot:success-icon) done
    v-row#protocol(v-if='!options.hide.protocol')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template
          | {{ $t("integrations.protocol") }}
      v-col(cols=12)
        ValidatedField(:name='$t("integrations.protocol")' rules='required')
          md-select(
            v-model='requestTemplate.protocol'
            rules='required',
            :disabled='options.protocol.disabled || readOnly')
            md-option(value='https://') https
            md-option(value='http://') http
          md-icon.error(v-slot:error-icon) close
          md-icon.success(v-slot:success-icon) done
    v-row#host(v-if='!options.hide.host')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.urlHost") }}
      v-col(cols=12)
        ValidatedInput(
          :name='$t("integrations.urlHost")'
          rules='required'
          v-model='requestTemplate.host',
          :disabled='options.host.disabled || readOnly'
          type='text')
    ParametersExtractor(
      v-if='!options.hide.hostParams'
      v-model='requestTemplate.host'
      v-slot:default='{ parameters }')
      v-row(v-if='parameters && parameters.length > 0')
        v-col.py-0(cols=12)
          label.md-form-label.gray-color-label-template {{ $t("integrations.hostParameters") }}
        v-col(cols=12)
          ObjectEditor(
            v-model='requestTemplate.hostParameters',
            :readOnly='readOnly'
            @value-changes='$set(changes, "hostParameters", $event)',
            :allowedProps='parameters',
            :requiredProps='parameters'
            v-bind='options.hostParams')
    v-row#path(v-if='!options.hide.path')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.urlPath") }}
      v-col(cols=12)
        ValidatedInput(
          :name='$t("integrations.urlPath")'
          v-model='requestTemplate.path',
          :disabled='options.path.disabled || readOnly'
          type='text')
    ParametersExtractor(
      v-if='!options.hide.pathParams'
      v-model='requestTemplate.path'
      v-slot:default='{ parameters }')
      v-row(v-if='parameters && parameters.length > 0')
        v-col.py-0(cols=12)
          label.md-form-label.gray-color-label-template {{ $t("integrations.pathParameters") }}
        v-col(cols=12)
          ObjectEditor(
            v-model='requestTemplate.pathParameters',
            :readOnly='readOnly'
            @value-changes='$set(changes, "pathParameters", $event)',
            :allowedProps='parameters',
            :requiredProps='parameters'
            v-bind='options.pathParams')
    v-row#queryParameters(v-if='!options.hide.queryParams')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.queryParameters") }}
      v-col(cols=12)
        ObjectEditor(
          @value-changes='$set(changes, "queryParameters", $event)',
          :readOnly='readOnly'
          v-model='requestTemplate.queryParameters'
          v-bind='options.queryParams')
        small(v-if='!hasQueryParams && readOnly' style='margin-left: 10px;')
          | {{ $t('integrations.none') }}
    v-row#headers(v-if='!options.hide.headers')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.headers") }}
      v-col(cols=12)
        ObjectEditor(
          @value-changes='$set(changes, "headers", $event)',
          :readOnly='readOnly'
          v-model='requestTemplate.headers'
          v-bind='options.headers')
        small(v-if='!hasHeaders && readOnly' style='margin-left: 10px;')
          | {{ $t('integrations.none') }}
    v-row#body(v-if='showJsonBody')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template {{ $t("integrations.body") }}
      v-col(cols=12)
        BodyJsonEditor(
          :previewMode='false'
          :readOnly='readOnly'
          v-model='requestTemplate.body'
          v-bind='options.bodyJson')
    ParametersExtractor(
      v-if='!options.hide.bodyParams',
      :value='requestTemplate.body'
      v-slot:default='{ parameters }')
      v-row(v-if='parameters && parameters.length')
        v-col.pb-0(cols=12)
          label.md-form-label.gray-color-label-template {{ $t("integrations.bodyParameters") }}
        v-col(cols=12)
          ObjectEditor(
            v-model='requestTemplate.bodyParameters',
            :readOnly='readOnly'
            @value-changes='$set(changes, "bodyParameters", $event)',
            :allowedProps='parameters',
            :requiredProps='parameters'
            v-bind='options.bodyParams')
    v-row#authType(v-if='!options.hide.authType')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template
          | {{ $t("integrations.authType") }}
      v-col(cols=12)
        ValidatedField(:name='$t("integrations.authType")' rules='required')
          md-select(
            v-model='requestTemplate.authType',
            :disabled='options.authType.disabled || readOnly')
            md-option(value='bearerToken') Bearer Token
            md-option(value='basic') Basic Auth
            md-option(value='none') {{ $t("integrations.none") }}
          md-icon.error(v-slot:error-icon) close
          md-icon.success(v-slot:success-icon) done
    v-row#auth(v-if='!options.hide.auth && authFields')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template
          | {{ $t("integrations.auth") }}
      v-col(cols=12)
        ValidatedInput(
          :name='authFields.keyName'
          rules='required',
          :disabled='readOnly'
          v-model='requestTemplate.auth[authFields.key]'
          type='text')
          template(v-slot:label) {{ authFields.keyName }}
      v-col(cols=12 style='padding-top: 0')
        ValidatedInput(
          :name='authFields.valueName'
          rules='required',
          :disabled='readOnly'
          v-model='requestTemplate.auth[authFields.value]'
          type='text')
          template(v-slot:label) {{ authFields.valueName }}
    v-row#resultVariable(v-if='!options.hide.resultVariable')
      v-col.py-0(cols=12)
        label.md-form-label.gray-color-label-template
          | {{ $t("integrations.resultVariable") }}
      v-col(cols=12 style='padding-top: 0')
        ValidatedInput(
          :name='$t("integrations.resultVariable")'
          rules='required|alpha_dash',
          :disabled='readOnly'
          v-model='requestTemplate.result_variable'
          @input='updateResultVariable'
          type='text')
  slot(name='actions')
</template>

<script>
import ParametersExtractor from '@/components/ParametersExtractor'
import ObjectEditor from '@/components/ObjectEditor'
import BodyJsonEditor from '@/components/BodyJsonEditor'
import ValidatedInput from '@/components/ValidatedInput'
import ValidatedField from '@/components/ValidatedField'
import URLPreviewer from '@/components/Reuse/URLPreviewer'
import merge from 'lodash.merge'
import { extend } from 'vee-validate'
import {
  required,
  email,
  confirmed,
  numeric,
  // eslint-disable-next-line camelcase
  alpha_dash
} from 'vee-validate/dist/rules'
import debounce from 'lodash.debounce'

extend('email', email)
extend('required', required)
extend('confirmed', confirmed)
extend('numeric', numeric)
extend('alpha_dash', alpha_dash)
// add rule for url path

function templateConstructor () {
  return {
    name: '',
    method: 'GET',
    protocol: 'https://',
    host: undefined,
    hostParameters: {},
    path: '/',
    pathParameters: {},
    body: undefined,
    bodyParameters: {},
    headers: {},
    queryParameters: {},
    authType: 'none',
    auth: {},
    requestType: 'rest',
    result_variable: 'success'
  }
}

function configConstructor () {
  return {
    hide: {},
    queryParams: {},
    name: { disabled: false },
    protocol: { disabled: false },
    authType: { disabled: false },
    host: { disabled: false },
    path: { disabled: false },
    method: { disabled: false },
    pathParams: {
      readOnlyKeys: true,
      disableAdding: true,
      disableRemoving: true
    },
    hostParams: {
      readOnlyKeys: true,
      disableAdding: true,
      disableRemoving: true
    },
    bodyParams: {
      readOnlyKeys: true,
      disableAdding: true,
      disableRemoving: true
    },
    bodyJson: {
      readOnly: false
    }
  }
}

export default {
  name: 'RequestTemplate',
  model: {
    prop: 'requestTemplate',
    event: 'update'
  },
  props: {
    requestTemplate: {
      type: Object,
      default: templateConstructor
    },
    config: {
      type: Object,
      default: configConstructor
    },
    readOnly: { type: Boolean, default: false }
  },
  components: {
    ParametersExtractor,
    URLPreviewer,
    ObjectEditor,
    ValidatedInput,
    ValidatedField,
    BodyJsonEditor
  },
  watch: {
    changes: {
      deep: true,
      handler () {
        this.$emit('changes', this.changes)
      }
    },
    config: {
      handler () {
        this.$set(this, 'options', merge(configConstructor(), this.config))
      },
      deep: true,
      immediate: true
    },
    'requestTemplate.authType' () {
      if (this.requestTemplate.authType === 'bearerToken') {
        this.$set(this.requestTemplate, 'auth', { prefix: 'Bearer' })
      } else {
        this.$set(this.requestTemplate, 'auth', {})
      }
    }
  },
  data () {
    return {
      options: {},
      changes: {
        bodyParameters: {},
        queryParameters: {},
        pathParameters: {},
        hostParameters: {},
        result_variable: ''
      }
    }
  },
  computed: {
    showJsonBody () {
      return !this.options.hide.body
    },
    hasQueryParams () {
      return Object.keys(this.requestTemplate.queryParameters || {}).length > 0
    },
    hasHeaders () {
      return Object.keys(this.requestTemplate.headers || {}).length > 0
    },
    authFields () {
      if (this.requestTemplate.authType === 'basic') {
        return {
          key: 'username',
          keyName: this.$t('commonWords.user'),
          value: 'password',
          valueName: this.$t('commonWords.password')
        }
      } else if (this.requestTemplate.authType === 'bearerToken') {
        return {
          key: 'prefix',
          keyName: this.$t('commonWords.prefix'),
          value: 'token',
          valueName: this.$t('commonWords.bearerToken')
        }
      } else {
        return null
      }
    }
  },
  methods: {
    reset () {
      this.$emit('update', templateConstructor())
    },
    updateResultVariable: debounce(function (value) {
      this.$set(this.changes, 'result_variable', value)
    }, 400),
    async validate () {
      const validator = this.$refs.validator
      const success = await validator.validate()
      // console.log(`validating`)
      if (!success) {
        // console.log(`no success`, validator.fields)
        for (const key of Object.keys(validator.fields).sort()) {
          if (validator.fields[key].invalid) {
            // console.log(`el`, validator.refs[key].$el)
            validator.refs[key].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
            return false
          }
        }
        return false
      }
      // console.log(`success!!`)
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.md-card-header {
  margin: 0;
}
.md-card {
  margin-bottom: 0;
}
.md-card .md-card-actions {
  border: none;
}

.md-card-header > h4 {
  color: white;
}
.md-form-label {
  align-self: center;
}
.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.pb-0 {
  padding-bottom: 0;
}
md-field > i.md-icon.md-icon-font.success.md-theme-default {
  margin-right: 20px;
}
.gray-color-label-template {
  color: #aaa !important;
}
</style>
